export const CURRENCY_SYMBOL = { USD: '$', EUR: '€', GBP: '£', INR: '₹', AUD: 'A$', CAD: 'C$', SGD: 'S$', AED: 'AED ', JPY: '¥', CHF: 'CHF ' };

export function fmt(value, unit = 'currency', currency = 'USD', opts = {}) {
  if (value === null || value === undefined || !Number.isFinite(value)) return 'N/A';
  const neg = value < 0;
  const abs = Math.abs(value);
  let text;
  const locale = opts.locale || 'en-US';
  if (unit === 'pct') text = `${(abs * 100).toLocaleString(locale, { minimumFractionDigits: opts.decimals ?? 1, maximumFractionDigits: opts.decimals ?? 1 })}%`;
  else if (unit === 'currency') text = `${opts.symbol === false ? '' : CURRENCY_SYMBOL[currency] || ''}${abs.toLocaleString(locale, abs > 0 && abs < 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 4 } : abs < 100 && abs !== Math.round(abs) ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 })}`;
  else if (unit === 'integer' || unit === 'count' || unit === 'days') text = abs.toLocaleString(locale, { maximumFractionDigits: 0 });
  else text = abs.toLocaleString(locale, { maximumFractionDigits: 1 });
  if (neg && abs < 0.005 && unit !== 'pct') return text;
  return neg ? `(${text})` : text;
}

export function compact(value, currency = 'USD', locale = 'en-US') {
  if (value === null || value === undefined || !Number.isFinite(value)) return 'N/A';
  const neg = value < 0; const abs = Math.abs(value);
  const sym = CURRENCY_SYMBOL[currency] || '';
  const text = abs >= 1e6 ? `${sym}${(abs / 1e6).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m` : abs >= 1e3 ? `${sym}${(abs / 1e3).toLocaleString(locale, { maximumFractionDigits: 0 })}k` : `${sym}${abs.toLocaleString(locale, { maximumFractionDigits: 0 })}`;
  return neg ? `(${text})` : text;
}

export function pctInput(v) { return v === null || v === undefined ? '' : String(Math.round(v * 100000) / 1000); }
export function fromPctInput(s) { const n = parseFloat(s); return Number.isFinite(n) ? n / 100 : null; }

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
